module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/gold_right_2.ebb303ae.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/gold_right_2.png
// module id = 2863
// module chunks = 11